<template lang="html">
<aside class="sl-sidebar">
  <!-- <div class="logo">
    <img class="m_logo" :src="`/static/${$store.state.theme.name}/logo_login.png`" alt=""></img>
  </div> -->
  <!-- <div class="sl-username">
    <p>{{$store.state.user.userinfo.merchantName}}</p>
  </div> -->
  <el-menu :default-active="currentPage" :unique-opened="true" :router="true">
    <template v-for="(item,index) in slider">
      <div class="sl-sidebar-border" v-if="item.menu === '/coupons'"></div>
      <el-menu-item :index="item.url" v-if="item.children.length === 0" >
        <div style="height: 20px;line-height: 20px;display: inline-block;">
          <i :class="item.icon" style="margin-right: 5px;" ></i>{{ item.name }}
        </div>
      </el-menu-item>
      <div class="sl-sidebar-border" v-if="item.menu === '/dashboard'"></div>
      <div class="sl-sidebar-border" v-if="item.menu === '/coupons'"></div>
      <el-submenu :index="index.toString()" v-if="item.children.length !== 0">
        <template slot="title">
          <div style="height: 20px;line-height: 20px;display: inline-block;">
            <i :class="item.icon" style="margin-right: 5px;" ></i>
            {{ item.name }}
          </div>
        </template>
        <el-menu-item v-for="(it,i) in item.children" :index="it.menu">
          <div style="height: 20px;line-height: 20px;display: inline-block;">
            <i class="fa fa-crosshairs" style="margin-right: 5px;"></i>
            {{ it.name }}
          </div>
        </el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
  <div class="sl-sidebar-app" v-show=false>
    <img :src="`/static/${this.$store.state.theme.name}/sidebar-logo.png`" alt="" class="sidebar-logo">
    <p class="name-app">{{$t('Navigator.appName')}}</p>
    <img src="./assets/imgs/qrcode.png" alt="" class="qrcode-app">
    <p class="category-app">iOS & Android</p>
  </div>
</aside>
</template>

<script>
import './assets/styles/slider.css'
export default {
  name: 'slider',
  computed: {
    slider() {
      return this.$store.state.user.slider
    },
    currentPage() {
      return this.$route.path === '' ? this.$store.state.user.userinfo.pageIndex : this.$route.path
    },
    level1() {
      return this.hasLevel('/dashboard')
    }
  },
  methods: {
    hasLevel(name) {
      let bl = false
      this.$store.state.user.slider.map(item => {
        if (item.menu === name) {
          bl = true
        }
      })
      return bl
    }
  }
}
</script>

<style>
.m_logo {
  width: 158px;
  margin-left: 10px;
}
.logo{
background-color: #fff;
margin-left: -100px;
}
</style>



// WEBPACK FOOTER //
// Slider.vue?28b63b7a